// Kept for existing imports; implementation lives in utils/format.js.
import { formatNumber } from './format';

export { formatNumber };
export const formatNumberUS = value => formatNumber(value);
